<div class="matrix-page">
  <div class="matrix-header">
    <h1>Term mapping matrix</h1>
    <p>Every general term next to what each configured country calls it. Type-specific overrides aren't shown here — see Term rules for those.</p>
  </div>

  <div class="toolbar">
    <input
      [(ngModel)]="termSearch"
      name="termSearch"
      (ngModelChange)="onSearchChange()"
      placeholder="Filter by term (e.g. bizStep)"
    />
  </div>

  <app-error-banner [message]="errorMessage()" />

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (generalTerms().length === 0) {
    <app-empty-state message="No general terms configured yet." />
  } @else if (countries().length === 0) {
    <app-empty-state message="No country term rules configured yet." />
  } @else {
    <div class="matrix-scroll">
      <table>
        <thead>
          <tr>
            <th>General term</th>
            @for (country of countries(); track country) {
              <th>{{ countryLabel(country) }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (term of pagedTerms; track term.id) {
            <tr>
              <td><code>{{ term.term }}</code></td>
              @for (country of countries(); track country) {
                <td>
                  <span class="cell-value">
                    @if (isOverride(term.term, country)) {
                      <code>{{ cell(term.term, country) }}</code>
                    } @else {
                      <span class="muted">{{ term.term }} (default)</span>
                    }
                    @if (canEdit) {
                      <button
                        class="edit-cell-btn"
                        (click)="editCell(term.term, country)"
                        aria-label="Edit local name"
                        title="Edit local name"
                      >
                        <svg class="edit-pen-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path class="edit-pen-icon__pen" d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
                          <line class="edit-pen-icon__underline" x1="4" y1="21.5" x2="9.5" y2="21.5" />
                        </svg>
                      </button>
                    }
                  </span>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div class="page-size-control">
        <span>Results per page</span>
        <app-page-size-select [sizes]="pageSizeOptions" [ngModel]="pageSize()" (ngModelChange)="onPageSizeChange($event)" name="pageSize" />
      </div>

      <div class="pagination-pill">
        <button class="page-nav" (click)="goToPage(page() - 1)" [disabled]="page() === 0">
          <span class="material-icons">chevron_left</span>
          Previous
        </button>
        @for (p of pageWindow; track $index) {
          @if (p === -1) {
            <span class="page-ellipsis">…</span>
          } @else {
            <button class="page-dot" [class.page-dot--active]="p === page()" (click)="goToPage(p)">
              {{ p + 1 }}
            </button>
          }
        }
        <button class="page-nav" (click)="goToPage(page() + 1)" [disabled]="page() === totalPages - 1">
          Next
          <span class="material-icons">chevron_right</span>
        </button>
        <span class="pagination-divider"></span>
        <span class="pagination-summary">Showing {{ rangeStart }}–{{ rangeEnd }} of {{ totalCount }} terms</span>
      </div>
    </div>
  }
</div>
